import { TranslationKey, useTranslation } from 'module/hooks/use-translation';
import {
  NumberFieldFilter,
  NumberFilterOperationType,
} from 'module/types/filter-field/filter/number';
import { snakeCase, startCase } from 'lodash';
import { FC } from 'react';
import { removeTrailingDots } from './utils';

export const NumberFilterToText: FC<{ filter: NumberFieldFilter }> = ({
  filter,
}) => {
  const {
    field: { fieldLabel },
    type,
  } = filter;

  return (
    <span>
      {startCase(fieldLabel)}{' '}
      {removeTrailingDots(
        useTranslation(
          `task_list.filters.${snakeCase(type)}` as TranslationKey,
        ),
      )}{' '}
      {filter.type === NumberFilterOperationType.Is ||
      filter.type === NumberFilterOperationType.IsGreaterThan ||
      filter.type === NumberFilterOperationType.IsLessThan
        ? filter.value
        : null}
    </span>
  );
};
